import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CommunityReducers } from 'src/app/core/state/app.reducers';
import { CommunityState } from './community.state';

const selectCommunitysState = createFeatureSelector<CommunityState>(CommunityReducers.TAG);

export const selectData = createSelector(selectCommunitysState, (state) => state.data);
export const selectPages = createSelector(selectCommunitysState, (state) => state.pages);
export const selectCachedPages = createSelector(selectCommunitysState, (state: CommunityState) => state.cachedPages);
export const selectPagedData = createSelector(selectData, selectPages, (data, pages) => ({ ...data, pages }));
export const selectGridSearch = createSelector(selectCommunitysState, (state) => state.gridSearch);
export const selectStatus = createSelector(selectCommunitysState, (state) => state.status);
export const selectSort = createSelector(selectCommunitysState, (state) => state.sort);
